<template>
  <v-card
    elevation="10"
    width="100%"
    :loading="isLoading"
  >
    <v-card-title>
      Meu Plano
      <v-spacer/>
    </v-card-title>
    <v-card-text>
      <v-skeleton-loader
        v-if="isLoading"
        :loading="isLoading"
        type="table"
        class="mx-auto flex-fill"
        width="100%"
      />
      <v-scale-transition>
        <v-data-table
          v-if="!isLoading"
          :headers="myPlanHeader"
          :items="myPlanData"
          disable-filtering
          disable-pagination
          disable-sort
          hide-default-footer
        >
          <template v-slot:header.flCredits="{ header }">
            {{ header.text }}
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  v-on="on"
                  color="info"
                  class="ml-1 mb-2"
                >
                  mdi-alert-circle
                </v-icon>
              </template>
            </v-tooltip>
          </template>
          <template v-slot:item.flCredits="{ item }">
            <span class="blue--text text--darken-4">{{item.flCredits | toFixedWithComma}}</span>
          </template>
        </v-data-table>
      </v-scale-transition>
    </v-card-text>
    <div class="my-plan-buttons-div" v-if="subsIsAboutToEnd">
      <!-- <v-btn                        
        @click="handleCancelSubscription"
        color="primary"
        :disabled="btnDisable"
        outlined
      >
        Alterar plano
      </v-btn>                       -->
      <v-btn                      
        @click="handleCancelSubscription"
        color="accent"
        :disabled="btnDisable"
        outlined
      >
        Cancelar assinatura
      </v-btn>
    </div>
  </v-card>
</template>

<script>
  import {getUserCredits, listUserHectarePackage, cancelSubscription} from "../../api/api-billing"
  import {includes} from "lodash/collection"
  import moment from "moment"
  import {DIALOG_TYPES, DialogOptions} from "../../helpers/dialogs"
  import {NOTIFICATION_TYPES, NotificationOptions} from "../../helpers/notify"
  import {mapGetters} from "vuex"
  import {GET_USER_DATA} from "../../store/modules/user"

  export default {
    name: "MyPlan",
    data: () => ({
      isLoading: true,
      subsIsAboutToEnd: false,
      btnDisable: false,
      flUserCreditsConverted: 0,
    }),
    filters: {
      toFixedWithComma(value) {
        return value.toFixed(2).replace(".", ",")
      }
    },
    computed: {
      ...mapGetters({
        getUserData: GET_USER_DATA,
      }),
      chargeTypeIsCredits() {
        if (this.$subsMng.subscriptionPlan["str_charge_type_system"] == 'credits')
          return true
        return false
      },   
      myPlanHeader() {
        return [
          {text: "Plano", value: "strPlan"},
          {text: "Método de pagamento", value: "strPaymentMethod"},
          {text: "Vencimento", value: "strDueDateInfo"}
        ]          
      },
      myPlanData() {
        return [
          {
            strPlan: this.$subsMng.subscriptionPlan ? this.$subsMng.subscriptionPlan["nm_subscription_plan"] : "Nenhum plano",
            strPaymentMethod: this.strPaymentMethod,
            strDueDateInfo: this.strDueDateInfo,
            flCredits: this.flUserCreditsConverted
          }
        ]
      },
      strPaymentMethod() {
        if (this.$subsMng.isSubscriptionEmpty) return ""
        if (!this.$subsMng.subscription["bl_activated"]) return ""
        if (includes(this.$subsMng.subscriptionPlan["ab_subscription_plan"], "TRIAL")) return "Cartão de crédito"

        switch (this.$subsMng.subscriptionPlan["ab_payable_with"]) {
          case 'ALL':
            return "Cartão de crédito e boleto"
          case 'credit-card':
            return "Cartão de crédito"
          case 'postpay':
            return "Boleto bancário"
          default:
            return ""
        }
      },
      remainingDays() {
        const dtDue = moment(this.$subsMng.subscription["dt_due"], moment.ISO_8601).add(1, 'days')
        const dtNow = moment(new Date(), moment.ISO_8601)
        return dtDue.diff(dtNow, "days")
      },
      strDueDateInfo() {
        if (this.$subsMng.isSubscriptionEmpty) return ""
        if (!this.$subsMng.subscription["bl_activated"]) return ""
        if (!this.$subsMng.subscription["dt_due"]) return ""

        let inputDate = new Date(moment(this.$subsMng.subscription["dt_due"], moment.ISO_8601).add(-1, 'days'));
        let day = inputDate.getDate();
        let month = inputDate.getMonth() + 1; // Month is 0-based, so add 1
        let year = inputDate.getFullYear();
        var outputDate = day + '/' + (month < 10 ? '0' : '') + month + '/' + year;

        if (this.remainingDays <= 0) return "Sua assinatura está vencida"

        return `${outputDate}`
      },
    },
    methods: {
      checkSubsIsAboutToEnd() {
        console.log(this.$subsMng.subscription["dt_due"])
        console.log(this.remainingDays)
        // check if the due date is less than 30 days from today
        if (this.remainingDays < 30) return true
        else return false
      },
      handleCancelSubscription() {

        const stripeCustomerId = this.getUserData["strStripeCustomerId"] 
        console.log(`Stripe Customer ID: ${stripeCustomerId}`)

        this.$dialog(new DialogOptions({
          title: "Cancelar assinatura",
          content: `Você tem certeza que deseja cancelar o seu plano de assinatura?<br>Você não terá mais acesso e todos os seus dados serão excluídos.`,
          confirmText: "SIM, DEFINITIVAMENTE",
          cancelText: "DEPOIS",
          type: DIALOG_TYPES.CONFIRM,
          onConfirm: () => {
            console.log("You are canceling")
            let sendData = {
              "str_stripe_customer_id": stripeCustomerId
            }
            cancelSubscription(this.$apiAuth.getAuthToken(), sendData)
              .then(() => {
                this.$dialog(new DialogOptions({
                title: "Aviso",
                content: "Nossa equipe irá processar o seu cancelamento.",
                cancelText: "Entendi",
                type: DIALOG_TYPES.ALERT
                }))
              })
              .catch(() => {
                this.$notify(new NotificationOptions({
                  message: "Erro ao processar operação.",
                  type: NOTIFICATION_TYPES.ERROR,
                }))
              })
          },
        }))
      },
    },
    created() {
      this.isLoading = true
      const getSubscriptionPromise = this.$subsMng.getSubscription(this.$apiAuth.getAuthToken())

      const getUserCreditsPromise = getUserCredits(this.$apiAuth.getAuthToken())
        .then(res => {
          const userCredits = res.data.data
          this.flUserCreditsConverted = userCredits["int_user_credits"] / 100
        })

      const listUserHectarePackagePromise = listUserHectarePackage(this.$apiAuth.getAuthToken())
        .then((res) => {              
          const userPackages = res.data.data   
          this.packages = userPackages          
        })

      Promise.all([getSubscriptionPromise, getUserCreditsPromise, listUserHectarePackagePromise])
        .finally(() => {
          this.subsIsAboutToEnd = this.checkSubsIsAboutToEnd()
          this.isLoading = false
        })
    }
  }
</script>

<style scoped lang="scss">
  .my-plan-buttons-div {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 2rem;
    margin-right: 2rem;
  }
</style>
